export const LZ_CHAIN_ID = {
  // ethereum
  '1': 30101,
  // ethereum sepolia
  '11155111': 40161,
  // bsc
  '56': 30102,
  // avalanche
  '43114': 30106,
  // polygon
  '137': 30109,
  // arbitrum
  '42161': 30110,
  // fantom
  '250': 30112,
  // metis
  '1088': 30158,
  // bsc-testnet
  '97': 40102,
  // fuji
  '43113': 40106,
  // mumbai
  '80002': 40109,
  // arbitrum-sepolia
  '421614': 40231,
  // fantom-testnet
  '4002': 40112,
  // metis-testnet
  '599': 40156,
  // base
  '8453': 30184,
  // base sepolia
  '84532': 40245
}
